import { createApi } from "@reduxjs/toolkit/dist/query/react";

import { httpService } from "@services/http.service";

import {
  IGetAuthTokenApiParams,
  IGetAuthTokenApiResponse,
} from "./auth-token.types";

export const authTokenApi = createApi({
  reducerPath: "authTokenApi",
  baseQuery: httpService({
    baseUrl: `/api/v1`,
  }),
  tagTypes: ["authTokenData"],
  endpoints: (build) => ({
    getAuthToken: build.query<IGetAuthTokenApiResponse, IGetAuthTokenApiParams>(
      {
        query: ({ userId, params }) => ({
          url: `/user/auth/token/${userId}/`,
          method: "get",
          params,
        }),
        providesTags: () => ["authTokenData"],
      },
    ),
  }),
});

export const { useGetAuthTokenQuery, useLazyGetAuthTokenQuery } = authTokenApi;
